import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import "../assets/storeDashboard/dashboard.css";
import { getLocalChargesAndDiscount, getLocalGarmentPack, getLocalPaymentMode, getLocalStorePaymentGatewayConfig, getNextPickupTime, getStoreLocalData, getUserData, setLocalChargesAndDiscount, setLocalGarmentPack, setLocalPaymentMode, setLocalStorePaymentGatewayConfig, setNextPickupTime } from "../utils/localStorage";
import {
  getStoreNewPick,
  getStoreOrderDashboard,
  getStoreOrderDashboardNew,
} from "../services/DashboardAPI/DashboardApi";
import { formatDate } from "../constants/DateUtil/DateUtil";
import { useNavigate } from "react-router-dom";
import AddNewCustomer from "./AddNewCustomer/AddNewCustomer";
import StoreMenu from "./StoreMenu";
import TabMenu from "./TabMenu";

import qz from "qz-tray";
import ButtonLink from "../ButtonLink";
import { SubscriptionExpiryAlert } from "./ExpiredSoon";
import PickupNotification from "../assets/sounds/pickup-notification.mp3"

import {
  Bar,
  Line,
  Pie,
  Doughnut,
  Radar,
  PolarArea,
  Scatter,
  Bubble,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale,
} from "chart.js";
import { getViewPaymentMode, getViewPaymentModeV2 } from "../services/paymentMode/paymentMode";
import { getStorePaymentGatewayConfig } from "../services/PaymentGatewayConfig/PaymentGatewayConfig";
import { getChargesAndDiscount } from "../services/Cart/getChargesAndDiscount";
import { Toast } from "primereact/toast";
import { getGarmentPack } from "../services/GarmentCategory/GarmentCategory";

// Register components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale
);

const { innerWidth: width, innerHeight: height } = window;

const backgroundImages = [
  "/Laundy_App_Icons_Gifs/Home_Page/Delivery.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Pickup.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Today_bookings.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Reprocess.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Rider_delivery.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Pending_orders.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Rider_pickup.png",
  "/Laundy_App_Icons_Gifs/Home_Page/darkGreen.png",
  "/Laundy_App_Icons_Gifs/Home_Page/blue.png",
  "/Laundy_App_Icons_Gifs/Home_Page/brown.png",
  "/Laundy_App_Icons_Gifs/Home_Page/grey.png",
  "/Laundy_App_Icons_Gifs/Home_Page/orange.png",
  "/Laundy_App_Icons_Gifs/Home_Page/pink.png",
  "/Laundy_App_Icons_Gifs/Home_Page/wine.png",
  "/Laundy_App_Icons_Gifs/Home_Page/seaGreen.png",
];

const StoreDashboardNew = () => {
  const navigate = useNavigate();

  const { userProfileData, storeData, brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const storeId = storeData.id;
  let brandId = brandProfileData.id;

  const subscriptionExpiryDate = userProfileData.nextRenewalOn;
  const enabledCustomerRevenueDetail = storeData.enabledCustomerRevenueDetail;
  const enabledCustomerRevenueDetailV2 = storeData.enabledCustomerRevenueDetailV2;
  const enabledNewPickupStoreNotified = storeData.enabledNewPickupStoreNotified;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;  

  const enabledAddInternationalCustomer =
    storeData.enabledAddInternationalCustomer;
  const mandatoryCustomerDetail = storeData?.mandatoryCustomerDetail;

  const base64String = `data:image/png;base64,${storeData.logo}`;
  const [addNewCustomerModalVisible, setAddNewCustomerModalVisible] =
    useState(false);

  const toast = useRef(null);
  const audioRef = useRef(null);
  const hasNotifiedRef = useRef(false);

  const [dashboardData, setDashboardData] = useState([]);
  const [visible, setVisible] = useState(false);

  const chartsGradientOrder = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const [orderDataNew, setOrderDataNew] = useState({});
  const [orderDataNew2, setOrderDataNew2] = useState({});

  const fetchStoreOrderDashboard = () => {
    getStoreOrderDashboardNew(storeId)
      .then((response) => {
        const Res = response.data.data;
        const newRes = Res?.map((item, index) => ({
          ...item,
          backgroundImages: backgroundImages[index],
          gradientCenterColor: chartsGradientOrder[item.status], // Assuming getRandomColor() generates a random color
        }));

        const resultOrderDataNew = {
          labels: newRes?.map(
            (item) => item.count + " - " + item.status?.replace(/BY_/g, " ")
          ),
          datasets: [
            {
              label: "Total Order",
              data: newRes?.map((item) => item.count),
              backgroundColor: newRes?.map((item) => item.gradientCenterColor),
            },
          ],
        };

        const resultOrderDataNew2 = {
          labels: newRes?.map(
            (item) =>
              item.itemGarmentCount + " - " + item.status?.replace(/BY_/g, " ")
          ),
          datasets: [
            {
              label: "Total Piece",
              data: newRes?.map((item) => item.itemGarmentCount),
              backgroundColor: newRes?.map((item) => item.gradientCenterColor),
              borderRadius: 2, // rounded corners
              barThickness: 20, // bar width
              borderSkipped: false, // rounded on both sides
            },
          ],
        };
        setOrderDataNew(resultOrderDataNew);
        setOrderDataNew2(resultOrderDataNew2);
        setDashboardData(newRes);
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "bottom" },
      title: {
        display: true,
        text: "Orders",
        font: {
          size: 18,
        },
      },
    },
  };

  const chartOptions2 = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: 0,
            weight: "bold",
          },
        },
      },
      title: {
        display: true,
        text: "Piece",
        font: {
          size: 18,
        },
      },

      tooltip: {
        backgroundColor: "#333",
        titleFont: { size: 14 },
        bodyFont: { size: 13 },
        padding: 10,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
          },
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(200,200,200,0.2)",
        },
        ticks: {
          stepSize: 5,
          font: {
            size: 13,
          },
        },
      },
    },
  };

  //  const Data = {
  //    labels: ["Rent", "Food", "Bills"],
  //    datasets: [
  //      {
  //        label: "Doughnut",
  //        data: [500, 200, 300],
  //        backgroundColor: ["purple", "orange", "green"],
  //      },
  //    ],
  //  };

  const [isConnected, setIsConnected] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  const [paymentModeList, setPaymentModeList] = useState([])
  const [storePaymentGatewayData, setStorePaymentGatewayData] = useState([]);
  const [storeChargesAndDiscount, setStoreChargesAndDiscount] = useState([])
  const [storeGarmentPack, setStoreGarmentPack] = useState([])

  const fetchPaymentMode = async () => {
    try {
      const response = await getViewPaymentModeV2(brandId);
      if (!response.data.error) {
        const Res = response.data;
        setPaymentModeList(Res);
        setLocalPaymentMode(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };


  // remove after 06/07/2026 release

  const fetchLocalPaymentMode = async () => {
    const { paymentMode } = getLocalPaymentMode();
    // if (paymentMode && Object.keys(paymentMode).length > 0) {
    //   setPaymentModeList(paymentMode);
    // } else {
      await fetchPaymentMode();
    // }
  };

  const fetchStorePaymentGatewayConfig = async () => {
    try {
      const response = await getStorePaymentGatewayConfig(storeId);
      if (!response.data.error) {
        const Res = response.data;
        setStorePaymentGatewayData(Res);
        setLocalStorePaymentGatewayConfig(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalStorePaymentGatewayConfig = async () => {
    const { storePaymentGatewayConfig } = getLocalStorePaymentGatewayConfig();
    if (
      storePaymentGatewayConfig &&
      Object.keys(storePaymentGatewayConfig).length > 0
    ) {
      setStorePaymentGatewayData(storePaymentGatewayConfig);
    } else {
      await fetchStorePaymentGatewayConfig();
    }
  };

  const fetchStoreChargesAndDiscount = async () => {
    try {
      const response = await getChargesAndDiscount(storeId);
      if (!response.data.error) {
        const Res = response.data;
        setStoreChargesAndDiscount(Res);
        setLocalChargesAndDiscount(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalChargesAndDiscount = async () => {
    const { chargesAndDiscount } = getLocalChargesAndDiscount();
    if (chargesAndDiscount && Object.keys(chargesAndDiscount).length > 0) {
      setStoreChargesAndDiscount(chargesAndDiscount);
    } else {
      await fetchStoreChargesAndDiscount();
    }
  };

  const fetchStoreGarmentPack = async () => {
    try {
      const response = await getGarmentPack(brandId);
      if (!response.data.error) {
        const Res = response.data;
        setStoreGarmentPack(Res);
        setLocalGarmentPack(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalGarmentPack = async () => {
    const { garmentPack } = getLocalGarmentPack();
    if (garmentPack && Object.keys(garmentPack).length > 0) {
      setStoreGarmentPack(garmentPack);
    } else {
      await fetchStoreGarmentPack();
    }
  };

  const showInfo = (data) => {
    toast.current?.show({
      severity: "info",
      summary: "Notification",
      detail: `You got a ${data > 1 ? data : ""} new pick up request, please check`,
      life: 10000,
    });

    // 🔊 Play sound
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // restart sound
      audioRef.current.play().catch(() => {
        // autoplay might be blocked until user interaction
      });
    }
  };

  // useEffect(() => {
  //   const unlockAudio = () => {
  //     if (audioRef.current) {
  //       audioRef.current.play().then(() => {
  //         audioRef.current.pause();
  //         audioRef.current.currentTime = 0;
  //       });
  //     }
  //     document.removeEventListener("click", unlockAudio);
  //   };

  //   document.addEventListener("click", unlockAudio);

  //   return () => document.removeEventListener("click", unlockAudio);
  // }, []);

  const fetchStoreNewPick = async () => {
    try {
      const response = await getStoreNewPick(storeId);

      if (!response.data.error) {
        if (response.data > 0 && !hasNotifiedRef.current) {
          showInfo(response.data);
          hasNotifiedRef.current = true;
        }

        // reset when no pickup exists
        if (response.data === 0) {
          hasNotifiedRef.current = false;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (enabledNewPickupStoreNotified) {

      // Initialize timer if not present
      if (!getNextPickupTime()) {
        setNextPickupTime();
      }

      const interval = setInterval(() => {
        const nextTime = getNextPickupTime();
        const now = Date.now();

        if (now >= nextTime) {
          // ⏰ Time is zero → call API
          fetchStoreNewPick();

          // 🔄 Reset timer
          setNextPickupTime();
        }
      }, 1000); // check every second

      return () => clearInterval(interval);
    }
  }, [enabledNewPickupStoreNotified]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     fetchStoreNewPick();
  //   }, 15000); // 15 seconds

  //   return () => clearInterval(interval);
  // }, []);


  useEffect(() => {
    if (!isConnected) {
      connectToQZ();
    }

    fetchStoreOrderDashboard();
    fetchLocalPaymentMode();
    fetchLocalStorePaymentGatewayConfig();
    fetchLocalChargesAndDiscount();
    fetchLocalGarmentPack()
  }, []);

  const renderNewDashboardCard1 = () => {
    const totalOrder = dashboardData
      ?.filter((item) => item.status !== "CANCEL")
      .reduce((acc, item) => acc + item.count, 0);

    return (
      <div
        className="relative overflow-hidden mx-4 my-3"
        // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
        style={{ cursor: "pointer" }}
      >
        <img
          className=" h-9rem w-10rem"
          src={backgroundImages[2]}
          alt={"total orders"}
        />
        <div
          className="absolute pl-3 border-round-xs"
          style={{
            top: "20%",
          }}
        >
          <p className="text-white text-3xl font-bold uppercase">
            {totalOrder}
          </p>
          <p className="text-white text-base font-bold uppercase">
            {"Total Order"}
          </p>
        </div>
      </div>
    );
  };

  const renderNewDashboardCard2 = () => {
    const totalOrder = dashboardData
      ?.filter((item) => item.status === "CANCEL")
      .reduce((acc, item) => acc + item.count, 0);

    return (
      <div
        className="relative overflow-hidden mx-4 my-3"
        // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
        style={{ cursor: "pointer" }}
      >
        <img
          className=" h-9rem w-10rem"
          src={backgroundImages[3]}
          alt={"Cancel Order"}
        />
        <div
          className="absolute py-2 pl-3 border-round-xs"
          style={{
            top: "20%",
          }}
        >
          <p className="text-white text-3xl font-bold uppercase">
            {totalOrder}
          </p>
          <p className="text-white text-base font-bold uppercase">
            {"Cancel Order"}
          </p>
        </div>
      </div>
    );
  };

  const renderNewDashboardCard3 = () => {
    const totalRevenue = dashboardData
      ?.filter((item) => item.status !== "CANCEL")
      .reduce((acc, item) => acc + item.total, 0);

    return (
      <div
        className="relative overflow-hidden mx-4 my-3"
        // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
        style={{ cursor: "pointer" }}
      >
        <img
          className=" h-9rem w-10rem"
          src={backgroundImages[0]}
          alt={"Total Revenue"}
        />
        <div
          className="absolute py-2 pl-3 border-round-xs"
          style={{
            top: "20%",
          }}
        >
          <p className="text-white text-3xl font-bold uppercase">
            {storeLocalData?.currencySymbol} {enabledCustomerRevenueDetailV2 ? Number(totalRevenue)?.toFixed(enabledAmountRoundOff) : "XXXX"}
          </p>
          <p className="text-white text-base font-bold uppercase">
            {"Total Revenue"}
          </p>
        </div>
      </div>
    );
  };

  const renderNewDashboardCard4 = () => {
    const totalGarments = dashboardData
      ?.filter((item) => item.status !== "CANCEL")
      .reduce((acc, item) => acc + item.itemGarmentCount, 0);

    return (
      <div
        className="relative overflow-hidden mx-4 my-3"
        // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
        style={{ cursor: "pointer" }}
      >
        <img
          className=" h-9rem w-10rem"
          src={backgroundImages[1]}
          alt={"Processed"}
        />
        <div
          className="absolute py-2 pl-3 border-round-xs"
          style={{
            top: "20%",
          }}
        >
          <p className="text-white text-3xl font-bold uppercase">
            {totalGarments}
          </p>
          <p className="text-white text-base font-bold uppercase">
            {"Total Piece"}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-8rem border-round-bottom surface-0 sticky z-1 top-0"
        style={{
          "--border-radius": "50px",
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex flex-row ml-3 mr-3 pt-2">
          <div className="flex-1 flex flex-row">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div
                className="h-4rem w-4rem border-circle bg-white flex justify-content-center align-items-center cursor-pointer"
                onClick={() => navigate("/UserProfile")}
              >
                {storeData.logo ? (
                  <img
                    style={{ width: "35px" }}
                    src={base64String}
                    alt="logo"
                  />
                ) : (
                  <img
                    style={{ width: "35px" }}
                    src="/warehouse/warehouse_2.png"
                    alt="logo"
                  />
                )}
              </div>
            </div>
            <div className="flex-1 ml-3">
              <p className="text-white text-xl font-bold uppercase">
                {userProfileData.firstName?.replace(/_/g, " ")}{" "}
                {userProfileData.lastName?.replace(/_/g, " ")}
              </p>
              <p className="text-white text-base font-bold uppercase">
                Manager - {storeData.storeName?.replace(/_/g, " ")}
              </p>
              <p className="text-white text-sm font-light">
                <img
                  style={{ width: "10px", marginRight: 5 }}
                  src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Location.png"
                  alt="logo"
                />
                {storeData.address.fullAddress}
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "30px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
        <div className="flex-1 flex flex-row">
          <div
            className="flex-1 flex justify-content-start align-items-center relative mt-3 ml-5 h-3rem bg-white border-round-xl shadow-4"
            onClick={() => navigate("/searchCustomer")}
            style={{ cursor: "pointer" }}
          >
            <img
              style={{ width: "20px", marginLeft: 10, marginRight: 10 }}
              src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Search.png"
              alt="logo"
            />
            <p
              style={{
                color: "#75879B",
                fontSize: 16,
              }}
            >
              Search User By Name, Mobile No., Email & Address{" "}
            </p>
          </div>
          <div
            className="flex justify-content-center align-items-center"
            style={{ flex: 0.1 }}
          >
            <div className="flex justify-content-center align-items-center relative mt-3 h-3rem w-3rem bg-white border-circle shadow-4 align-self-center">
              <img
                style={{ width: "25px", cursor: "pointer" }}
                onClick={(e) => setAddNewCustomerModalVisible(true)}
                src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>

      {enabledCustomerRevenueDetail ? (
        <div className="flex flex-1" style={{ marginBottom: 100 }}>
          <div style={{ flex: 1 }}>
            <div
              className="px-0 ml-2 mr-2 relative  mt-5 flex justify-content-center align-items-center"
              style={{ flex: 1 }}
            >
              {renderNewDashboardCard1()}
              {renderNewDashboardCard3()}
            </div>
            <div
              className="px-0 ml-2 mr-2 relative  mt-1 flex justify-content-center align-items-center"
              style={{ flex: 1 }}
            >
              {renderNewDashboardCard2()}
              {renderNewDashboardCard4()}
            </div>

            <div
              className="flex justify-content-center align-items-center"
              style={{ paddingTop: 10 }}
            >
              <button
                className="golden-button-new-dashboard"
                onClick={() => navigate("/full-dashboard")}
              >
                <span className="shine" />
                Full Dashboard{" "}
                <i
                  className="pi pi-send"
                  style={{
                    position: "relative",
                    top: 4,
                    marginLeft: 3,
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                ></i>
              </button>
            </div>
          </div>
          {dashboardData?.length > 0 ? (
            <div className="flex" style={{ flex: 1 }}>
              <div
                className="px-0 ml-5 mr-1 relative mt-5"
                style={{ flex: 0.5 }}
              >
                <div
                  className="flex  bg-white border-round-xl shadow-4"
                  style={{ height: height < 600 ? 280 : 350 }}
                >
                  <Bar
                    data={orderDataNew2}
                    options={chartOptions2}
                    height={300}
                    width={450}
                  />
                </div>
              </div>
              <div
                className="px-0 ml-5 mr-5 relative mt-5"
                style={{ flex: 0.5 }}
              >
                <div
                  className="flex  bg-white border-round-xl shadow-4"
                  style={{ height: height < 600 ? 280 : 350 }}
                >
                  <Doughnut data={orderDataNew} options={chartOptions} />
                </div>
              </div>
            </div>
          ) : (
            <div
              className="mt-6 mr-4 flex justify-content-center align-items-center bg-white border-round-xl shadow-4"
              style={{ flex: 1 }}
            >
              <p className="text-3xl font-bold">No Booking Found</p>
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-column" style={{ marginBottom: 100 }}>
          <div className="px-0 ml-5 mr-5 flex-1 mt-5 flex justify-content-center">
            <p className="text-3xl font-bold">No Dashboard To Display</p>
          </div>
          <div className="px-0 ml-5 mr-5 flex-1 mt-2 flex justify-content-center">
            <p className="text-3xl font-bold">
              You Have No Access To View This Dashboard
            </p>
          </div>
        </div>
      )}
      <TabMenu />
      {/*<audio preload="auto" src="https://qdc-static-assets.s3.ap-south-1.amazonaws.com/pickup-notifications/ding.mp3" loop=""></audio>*/}
      <audio
        ref={audioRef}
        preload="auto"
        // src="https://qdc-static-assets.s3.ap-south-1.amazonaws.com/pickup-notifications/ding.mp3"
        src={PickupNotification}
      />
      <div>
        <AddNewCustomer
          setAddNewCustomerModalVisible={setAddNewCustomerModalVisible}
          addNewCustomerModalVisible={addNewCustomerModalVisible}
          storeId={storeId}
          brandId={brandId}
          StoreAddress={storeData.address}
          enabledAddInternationalCustomer={enabledAddInternationalCustomer}
          mandatoryCustomerDetail={mandatoryCustomerDetail}
        />
        <StoreMenu setVisible={setVisible} visible={visible} />
      </div>
      <SubscriptionExpiryAlert expiryDate={subscriptionExpiryDate} />
      {/*<NotificationModal
        notificationModalVisible={open}
        setNotificationModalVisible={setOpen}
      />*/}
      <div className="flex justify-content-center">
        <Toast ref={toast} />
      </div>
      <ButtonLink />
    </div>
  );
};

export default StoreDashboardNew;
